import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useUser } from '@src/state/user/hooks';
import { storage } from '@uhg-abyss/web/tools/storage';
import { config } from '@uhg-abyss/web/tools/config';
import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';

export const SelectRegistrationSearchCriteria = ({
  selectedOption,
  inputModel,
  inputLabel,
  ...props
}) => {
  const form = useForm();

  const handleChange = (selected) => {
    if (selected) {
      form.setValue(inputModel, selected);
      if (selected === 'tin') {
        selectedOption({
          tin: true,
          requestId: false,
          trackingNum: false,
          isAllSelected: false,
        });
      } else if (selected === 'requestId') {
        selectedOption({
          tin: false,
          requestId: true,
          trackingNum: false,
          isAllSelected: false,
        });
      } else if (selected === 'referenceNumber') {
        selectedOption({
          tin: false,
          requestId: false,
          trackingNum: true,
          isAllSelected: false,
        });
      } else if (selected === 'isAllSelected') {
        selectedOption({
          tin: false,
          requestId: false,
          trackingNum: false,
          isAllSelected: true,
        });
      } else {
        selectedOption({
          tin: false,
          requestId: false,
          trackingNum: false,
          isAllSelected: false,
        });
      }
    } else {
      selectedOption({
        tin: false,
        requestId: false,
        trackingNum: false,
        isAllSelected: false,
      });
    }
  };

  useEffect(() => {
    form.setValue(inputModel, '');
  }, []);
  const userInfo = useUser.state();
  const isSuperUser = storage.local.get(userInfo.uuid);
  const options = [
    { label: 'TIN', value: 'tin' },
    { label: 'Reference Number', value: 'referenceNumber' },
  ];
  if (!(config('US3671382_SUPER_USER') && isSuperUser)) {
    options.push({ label: 'All', value: 'isAllSelected' });
  }
  return (
    <React.Fragment>
      <SelectInput
        {...props}
        id={inputLabel}
        label="Search by"
        options={options}
        onChange={handleChange}
        isSearchable
        isClearable
        placeholder="Select One"
        model={inputModel}
      />
    </React.Fragment>
  );
};

SelectRegistrationSearchCriteria.propTypes = {
  selectedOption: PropTypes.func,
  inputLabel: PropTypes.string.isRequired,
  inputModel: PropTypes.string.isRequired,
};

SelectRegistrationSearchCriteria.defaultProps = {
  selectedOption: () => {},
};
